import React, { createContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import wrap from "LIB/domHelpers";

const context = createContext({
  activeModalId: "",
  openModal: () => {},
  closeModal: () => {}
});
const { Provider, Consumer } = context;

export default class ImprovedDropDown extends React.Component {
  state = {
    open: false,
    activeModalId: null
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.onClickAway);
  }

  onClickAway = e => {
    if (!wrap(this.content).contains(e.target)) {
      this.closeModal();
    }
  };

  openModal = (ev, newModalId) => {
    ev.stopPropagation();
    ev.preventDefault();
    this.setState({
      activeModalId: newModalId,
      open: this.listen(false)
    });
  };

  closeModal = ev => {
    if (ev) {
      ev.stopPropagation();
      ev.preventDefault();
    }

    this.setState({
      activeModalId: null,
      open: this.listen(false)
    });
  };

  toggleOpen = ev => {
    ev.stopPropagation();
    ev.preventDefault();
    this.setState(state => ({ open: this.listen(!state.open) }));
  };

  listen(on = true) {
    if (on) {
      document.addEventListener("click", this.onClickAway);
    } else {
      document.removeEventListener("click", this.onClickAway);
    }

    return on;
  }

  render() {
    const {
      children,
      menuClass = "dropdown-menu-right",
      icon = "fa fa-fw fa-ellipsis-v",
      buttonClasses = "btn-link",
      buttonText,
      dropdownStyles = {},
      containerClasses = {},
      iconStyles = {}
    } = this.props;
    const { open, activeModalId } = this.state;

    return (
      <Provider
        value={{
          activeModalId,
          openModal: this.openModal,
          closeModal: this.closeModal
        }}
      >
        <div
          className={classNames("dropdown", { open }, containerClasses)}
          style={dropdownStyles}
        >
          <button className={buttonClasses} onClick={this.toggleOpen}>
            {buttonText || null} <i className={icon} style={iconStyles} />
          </button>
          <ul
            className={`dropdown-menu ${menuClass}`}
            ref={node => {
              this.content = node;
            }}
          >
            {children}
          </ul>
        </div>
      </Provider>
    );
  }
}

ImprovedDropDown.propTypes = {
  buttonText: PropTypes.string,
  menuClass: PropTypes.string,
  icon: PropTypes.string.isRequired,
  iconStyles: PropTypes.shape({}),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  containerClasses: PropTypes.shape({}),
  dropdownStyles: PropTypes.shape({}),
  buttonClasses: PropTypes.string
};

export function ImprovedDropDownItem({
  id,
  label,
  faIcon,
  renderActive,
  hideIf = false,
  disabled = false
}) {
  if (hideIf) return null;

  return (
    <Consumer>
      {({ openModal, closeModal, activeModalId }) => (
        <li
          onClick={ev => openModal(ev, id)}
          className={classNames({ disabled })}
        >
          <a
            className="btn-link"
            role="button"
            style={{ cursor: disabled ? "not-allowed" : "pointer" }}
          >
            <i className={`fa fa-fw fa-${faIcon}`} />
            &nbsp;{label}
          </a>
          {activeModalId === id &&
            // Inject open/close props into a cloned instance of our renderActive component.
            React.cloneElement(renderActive, {
              open: true,
              close: closeModal
            })}
        </li>
      )}
    </Consumer>
  );
}

ImprovedDropDownItem.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  faIcon: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  hideIf: PropTypes.bool,
  renderActive: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/DropDown/ImprovedDropDown.jsx